var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid mt-4"},[_c('h3',[_vm._v("Upload Training Data")]),_c('router-view',{attrs:{"files":_vm.files},on:{"drop":_vm.onDrop}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }